import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

import { ETabsModal } from '../interfaces';

export const getSearchPlaceholder = (
  t: TTranslator<TLocalesKeys>,
  type: ETabsModal
): string => {
  switch (type) {
    case ETabsModal.GOODS:
      return t('promo.position.choice.goods');
    case ETabsModal.SERVICES:
      return t('promo.position.choice.services');
    case ETabsModal.TARIFFS:
      return t('promo.position.choice.tariffs');
  }
};
